import { render, staticRenderFns } from "./SchedulerSpeakersShifts.vue?vue&type=template&id=97e9f694&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports